import {Component} from '@angular/core';

@Component({
    selector: 'kiwi-animator-mark-explanation',
    templateUrl: './animator-mark-explanation.component.html',
    standalone: false
})
export class AnimatorMarkExplanationComponent {

}
